import React from 'react';
import { connect } from 'react-redux';
import { Route, Link, NavLink, Switch, Redirect, withRouter } from 'react-router-dom';

import { matchPath } from 'react-router';

import Payouts from './payouts';
import Profile from './profile';
import AllStats from './allStats';
import AllStats2 from './allStats2';
import Invites from './invites';
import Affiliates from './affiliates';
import Chatsales from './chatsales';
import Links from './links';
import Agents from './agents';
import AffiliateSales from './affiliateSales';
import AffiliateEarnings from './payouts/earnings';
import Bonus from './bonus';
import smsChat from './smsChat';
import Stats from './stats';
import News from './news';
import NewsPopup from './news/popup';
import UserPostback from './userPostback';
import Domains from './domains';
import Mailer from './mailer';
import LinkStats from './links/stats';
import AllLinksStats from './allLinksStats';
import AffChecker from './affChecker';
import Fraud from './fraud';
import Hookupbay from './hookupbay';
import HookupbayTransactions from './hookupbay/transactions';
import Config from './config';
import AffLists from './affLists';
import Tracker from './tracker';

import config from '../config';

import NavLi from './elements/NavLi';

import api from '../actions/api';

import { domain, domainConfig } from '../helpers/domainConfig';
import { getSid } from 'src/helpers/session';
// const env = process.env.NODE_ENV

const avatar = require('assets/images/demo-avatar9604.jpg');

class Layout extends React.Component {
  state = {
    panelOpen: false
  };

  makePages = (user) => {
    const localhost =
      location.host.indexOf('.com') == -1 &&
      location.host.indexOf('.net') == -1 &&
      location.host.indexOf('.org') == -1;
    const pages = {
      payouts: {
        path: '/payouts',
        name: 'Payouts',
        icon: 'fa fa-paypal',
        component: Payouts
      },
      'affiliate/sales': {
        path: '/affiliate/:aid/sales',
        name: 'Sales',
        component: AffiliateSales
      },
      'affiliate/earnings': {
        path: '/affiliate/:aid/earnings',
        name: 'Earnings',
        component: AffiliateEarnings
      },
      affiliates: {
        path: '/affiliates',
        name: 'Affiliates',
        icon: 'fa fa-anchor',
        component: Affiliates
      },
      chatsales: {
        path: '/chatsales',
        name: 'Stats',
        icon: 'fa fa-line-chart',
        component: Chatsales
      },
      allStats: {
        path: '/all_stats',
        name: 'All stats',
        icon: 'fa fa-pie-chart',
        component: AllStats
      },
      allStats2: {
        path: '/all_stats2',
        name: 'All stats',
        icon: 'fa fa-pie-chart',
        component: AllStats2
      },
      invites: {
        path: '/invites',
        name: 'Invites',
        icon: 'fa fa-envelope',
        component: Invites
      },
      agents: {
        path: '/agents',
        name: 'Agents',
        icon: 'fa fa-male',
        component: Agents
      },
      // bonus: {
      //   path: '/bonus_sales',
      //   name: 'Bonus sales',
      //   icon: 'fa fa-male',
      //   component: Bonus
      // },
      links: {
        path: '/links',
        name: 'Links',
        icon: 'fa fa-rocket',
        component: Links
      },
      'links/stats': {
        path: '/link/:linkId/stats',
        name: 'Landing Stats',
        icon: 'fa fa-line-chart',
        component: LinkStats
      },
      allLinksStats: {
        path: '/all_links_stats',
        name: 'Landings stats',
        icon: 'fa fa-pie-chart',
        component: AllLinksStats
      },
      news: {
        path: '/news',
        name: 'News',
        icon: 'fa fa-bullhorn',
        component: News
      },
      user_postback: {
        path: '/user_postback',
        name: 'Postback',
        icon: 'fa fa-briefcase',
        component: UserPostback
      },
      profile: {
        path: '/profile',
        name: 'User info',
        icon: 'fa fa-user',
        component: Profile
      },
      domains: {
        path: '/domains',
        name: 'White labels',
        icon: 'fa fa-plane',
        component: Domains
      },
      // sms: {
      //   path: localhost ? "http://localhost:3600/smschat?cp2sid="+getSid() : "http://gbot.be/?cp2sid="+getSid(),
      //   name: "Gmails",
      //   icon: "fa fa-google"
      // },
      sms: {
        path: localhost
          ? 'http://localhost:3600/app?cp2sid=' + getSid()
          : 'http://sms.gbot.be/app?cp2sid=' + getSid(),
        name: 'SMS',
        icon: 'fa fa-google'
      },
      groupchat: {
        path: localhost
          ? 'http://localhost:3000/groupchat/test1'
          : 'http://foxvoo.com/groupchat/test1',
        name: 'Groupchat',
        icon: 'fa fa-wechat'
      },
      mailer: {
        path: '/mailer',
        name: 'Mailer',
        icon: 'fa fa-envelope',
        component: Mailer
      },
      search: {
        path: '/search',
        name: 'Search',
        icon: 'fa fa-anchor',
        component: AffChecker
      },
      hookupbay: {
        path: '/hookupbay',
        name: 'Hookupbay',
        icon: 'fa fa-envelope',
        component: Hookupbay
      },
      'hookupbay/transactions': {
        path: '/hookupbay_t/:member_id/transactions',
        name: 'Transactions',
        component: HookupbayTransactions
      },
      fraud_sales: {
        path: '/fraud_sales',
        name: 'Flagged sales',
        icon: 'fa fa-briefcase',
        component: Fraud
      },
      config: {
        path: '/config',
        name: 'Config',
        icon: 'fa fa-angellist',
        component: Config
      },
      afflists: {
        path: '/afflists',
        name: 'Aff Lists',
        icon: 'fa fa-angellist',
        component: AffLists
      },
      tracker: {
        path: '/tracker',
        name: 'Tracker',
        icon: 'fa fa-male',
        component: Tracker
      }
    };
    return pages;
  };

  logout = () => {
    this.props.api('auth/logout');
  };

  route = (pageId) => {
    let { path, component } = this.pages[pageId];
    this.routes.push(<Route key={path} path={config.basePath + path} component={component} />);
  };

  li = (pageId) => {
    let { path, name, icon, component } = this.pages[pageId];
    this.links.push(
      <NavLi to={config.basePath + path} key={path} activeClassName='active'>
        <Link to={config.basePath + path}>
          <span class='nav-icon'>
            <i class={icon}></i>
          </span>
          <small class='nav-text'>{name}</small>
        </Link>
      </NavLi>
    );
    if (!component) {
      component = Profile;
    }
    this.route(pageId);
  };

  lia = (pageId) => {
    let { path, name, icon, component } = this.pages[pageId];
    this.links.push(
      <li key={path}>
        <a href={path} target='_blank'>
          <span class='nav-icon'>
            <i class={icon}></i>
          </span>
          <small class='nav-text'>{name}</small>
        </a>
      </li>
    );
  };

  links = [];
  routes = [];
  lastUserId = null;
  makeMenu() {
    let user = this.props.user;
    if (this.lastUserId == user.aid) {
      return;
    } else {
      this.lastUserId = user.aid;
    }
    this.pages = this.makePages(user);
    let { route, li, lia } = this;
    this.links = [];
    this.routes = [];

    if (user.offers.length > 0 && user.aid == 5) li('news');

    if (user.role_id >= 2) {
      // li("payouts")
      route('affiliate/sales');
      route('affiliate/earnings');

      if (user.aid == 5) {
        route('allStats');
        li('allStats2');
      } else {
        li('allStats');
      }
      li('affiliates');
    }
    if (user.role_id >= 4) {
      li('domains');
      li('mailer');
    }
    li('profile');

    // user.sms_chat > 0 && li("/sms_chat","Sms chat","fa fa-align-left", smsChat)

    if (user.offers.length > 0) {
      if (user.postback_on == 1) li('user_postback');
      li('chatsales');
      if (user.role_id > 0) li('agents');
      li('links');
      if (user.role_id > 3 || user.autologin == 1) route('links/stats');
      if (user.role_id > 0) li('invites');
    }
    if (user.sms_chat == 1) {
      lia('sms');
    }
    // if (user.aid == 5) lia('groupchat');
    // if (user.aid == 5 || user.autologin == 1)
    li('allLinksStats');

    if (user.aid == 5 || user.aid == 1915) li('search');
    if (user.aid == 5) {
      // li('hookupbay');
      // route('hookupbay/transactions');
      li('fraud_sales');
      // li("config")
      route('config');
      li('afflists');
      // li('bonus');
    }

    if (user.role_id > 0) li('tracker');
  }

  componentWillMount() {
    this.makeMenu();
  }

  openPanel = (e) => {
    e.preventDefault();
    this.setState({ panelOpen: true });
  };
  closePanel = (e) => {
    if (this.state.panelOpen) {
      e.preventDefault();
      this.setState({ panelOpen: false });
    }
  };

  logBack = (e) => {
    this.props.logout();
    this.props.api('auth/logback');
  };

  getPageName = () => {
    let pages = this.pages;
    let pathname = this.props.router.location.pathname.replace(config.basePath + '/', '');
    var pageName = '';
    if (pages[pathname]) {
      pageName = (pages[pathname] && pages[pathname].name) || '';
    } else {
      if (pathname.indexOf('/sales') != -1) {
        const match = matchPath(this.props.history.location.pathname, {
          path: '/app/affiliate/:aid/sales',
          exact: true,
          strict: false
        });
        pageName = 'Sales of wid: ' + match.params.aid;
      } else if (pathname.indexOf('/earnings') != -1) {
        pageName = 'Earnings';
      } else if (pathname.indexOf('/transactions') != -1) {
        const match = matchPath(this.props.history.location.pathname, {
          path: '/app/hookupbay_t/:member_id/transactions',
          exact: true,
          strict: false
        });
        pageName = 'Transactions of member: ' + match.params.member_id;
      }
    }
    return pageName;
  };

  render() {
    if (!this.props.logged) {
      return <Redirect to={config.basePath + '/login'} />;
    }
    let user = this.props.user;
    this.makeMenu();
    let pageName = this.getPageName();

    let parentName = this.props.user.parent_name;
    let parentSkype = this.props.user.parent_skype;
    if (domainConfig.title === 'CarbonProfit') {
      parentName = 'Joe';
      parentSkype = '';
    }

    return (
      <div class='app'>
        <div
          id='aside'
          class={
            'app-aside fade box-shadow-x nav-expand white ' +
            (this.state.panelOpen ? 'show d-block' : '')
          }
          aria-hidden='true'
          onClick={this.closePanel}
        >
          <div class='sidenav modal-dialog dark dk'>
            <div class='navbar dark-white panel-logo'>
              <a href='/app' class='navbar-brand'>
                {domainConfig.logo.image && (
                  <img src='//www.cashplane.net/assets/img/cashplane3.png' alt='' />
                )}
                {domainConfig.logo.text && <span class='logo-text'>{domainConfig.logo.text}</span>}
              </a>
            </div>
            <div class='flex hide-scroll'>
              <div class='scroll'>
                <div class='nav-active-theme' data-nav>
                  <ul class='nav bg nav-profile'>
                    <li class='nav-header'>
                      <div class='media-thumb media-left thumb-bordereb'>
                        <a class='img-shadow' href='javascript:void(0);'>
                          <img class='thumb' src={avatar} />
                        </a>
                      </div>
                      <div class='media-body'>
                        <small class='panel-userrole'>{user.firstname + ' ' + user.lastname}</small>
                        <br />
                        <small class='panel-userrole'>{user.role}</small>
                      </div>
                    </li>
                    {user.sublogin && (
                      <li>
                        <Link to={config.basePath + '/all_stats'} onClick={this.logBack}>
                          back to {user.sublogin.name}
                        </Link>
                      </li>
                    )}
                  </ul>
                  <ul class='nav'>
                    {this.links.map((link) => link)}
                    <li class='pb-2 hidden-folded'></li>
                  </ul>
                </div>
              </div>
            </div>

            <div class='no-shrink lt'>
              <div class='nav-fold'>
                <div class='hidden-folded flex p-2 bg'>
                  {!!parentName && (
                    <div class='p-1'>
                      <div class=''>AM: {parentName}</div>
                    </div>
                  )}
                  {!!parentSkype && (
                    <div class='p-1'>
                      <div class=''>skype: {parentSkype}</div>
                    </div>
                  )}
                  <div class='d-flex p-1'>
                    <div class='flex text-nowrap'></div>
                    <a
                      href='#'
                      class='px-2'
                      data-toggle='tooltip'
                      title='Logout'
                      onClick={this.logout}
                    >
                      <i class='fa fa-power-off text-muted'></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <NewsPopup />
        <div class='app-content box-shadow-1 box-radius-1' role='main'>
          <div class='content-header white  box-shadow-1' id='content-header'>
            <div class='navbar navbar-expand-lg height-inherit'>
              <a class='d-lg-none mx-2' onClick={this.openPanel}>
                <svg xmlns='//www.w3.org/2000/svg' width='40' height='40' viewBox='0 0 512 512'>
                  <path d='M80 304h352v16H80zM80 248h352v16H80zM80 192h352v16H80z'></path>
                </svg>
              </a>
              <div class='navbar-text nav-title flex' id='pageTitle'>
                {pageName}
              </div>
              <a class='pull-right go-to-cp1' href='/cp1'>
                Go to {domainConfig.title} 1.0
              </a>
            </div>
          </div>
          <div class='content-main ' id='content-main'>
            <div class='p-3 container-page pull-left'>
              <Switch>{this.routes.map((route) => route)}</Switch>
            </div>
          </div>
        </div>

        {this.state.panelOpen && <div class='modal-backdrop fade show'></div>}
      </div>
    );
  }
}

import setState from '../actions/state';

export default connect(
  function (state, ownProps) {
    let user = state.session.user || {};
    return {
      logged: !!state.session.user,
      user: state.session.user,
      firstname: user.firstname,
      lastname: user.lastname,
      state: state.state.layout || state.state.initial,
      router: state.router
    };
  },
  {
    api,
    setState: setState('layout'),
    logout: function () {
      return {
        type: 'api',
        key: 'auth_logout',
        keepSid: true
      };
    }
  }
)(Layout);
